"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    APP: 'crimson-app',
    COMMUNITY: 'crimson-community',
};
//# sourceMappingURL=builtInCalendars.js.map